const MAPPINGS = {
  'search-form': {
    term: 't',
    titles: 'x',
    fuzziness: 'f',
    page: 'p',
    view: 'view'
  },
  'tagsearch-form': {
    value: 'v',
    term: 't',
    type: 'type',
    page: 'p'
  },
  paginated: {
    page: 'p'
  },
  browser: {
    display: 'd',
    tag : 'tag',
    textVisible: 'v',
    term: 't',
    fuzziness: 'f'
  }
}

function createMapperFromMapping(mapping) {
  const reverseMapping = Object
	.keys(mapping)
	.reduce((obj, key) => Object.assign(obj, { [mapping[key]]: key }), {})
  return {
    toURL(source, { ignore = [] } = {}) {
      if (typeof source === 'string') {
	return mapping[source]
      }

      const target = {}
      for (const key in source) {
	if (!ignore.includes(key)) {
	  target[mapping[key]] = source[key]
	}
      }
      return target
    },
    fromURL(source) {
      if (typeof source === 'string') {
	return reverseMapping[source]
      }

      const target = {}
      for (const key in source) {
	target[reverseMapping[key]] = source[key]
      }
      return target
    }
  }
}

export function createWatchers(target, handler, { ignore=[], immediate=true, deep=false } = {}) {
  const watchers = {}
  const mapping = MAPPINGS['search-form']
  const keys = Object.keys(mapping).filter((key) => !ignore.includes(key))
  for (const key of keys) {
    const value = mapping[key]
    console.assert(value !== undefined, 'unexpected value undefined')
    watchers[target + '.' + value] = {
      handler: typeof handler === 'function'
	? function (...args) { handler.call(this, ...args) }
	: handler,
      immediate,
      deep
    }
  }
  return watchers
}

export function createMapper(mappingName) {
  if (!(mappingName in MAPPINGS)) {
    throw new Error(`'${mappingName}' not in mappings`)
  }
  const mapping = MAPPINGS[mappingName]
  return createMapperFromMapping(mapping)
}
